import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';

//import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Importa el registro del Service Worker
//import { messaging } from './firebase/credenciales';

// Registro del Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registrado con éxito:');
    })
    .catch((error) => {
      console.error('Error al registrar el Service Worker:', error);
    });
} else {
  console.warn('Service Worker no es soportado en este navegador.');
}

// Crear el nodo raíz
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registra el Service Worker para habilitar las notificaciones push y otras funcionalidades offline
//serviceWorkerRegistration.register();

// Si quieres empezar a medir el rendimiento de tu aplicación, puedes pasar una función
// para registrar resultados (por ejemplo: reportWebVitals(console.log))
// o enviar a un endpoint de analítica. Aprende más: https://bit.ly/CRA-vitals
reportWebVitals();
